import { PASSING_ACCURACY } from "../../convex/types";

// Grade table lives in convex/types.ts so the highscore upsert mutation can
// compare grades server-side without duplicating it — re-exported here so
// existing `@/utils/grade` imports keep working.
export type { Grade } from "../../convex/types";
export { getGradeForAccuracy } from "../../convex/types";

/** Short congratulatory label for a given accuracy. */
export function getAccuracyLabel(accuracy: number): string {
  if (accuracy >= 95) return "Perfect!";
  if (accuracy >= 85) return "Great!";
  if (accuracy >= 75) return "Good!";
  if (accuracy >= PASSING_ACCURACY) return "Nice try!";
  return "Keep practicing!";
}
